import React from 'react'

import { Bodytext, Button, Heading } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

import { style } from 'theme'
import {
  PORTFOLIO_ALL_EDIT_PORTFOLIO,
  PORTFOLIO_CUSTOM_SUBHEADER,
} from 'utils/testing/testIDs'

const StyledOuterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 15px;
  padding: 0 10px;
  width: 100%;
  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    margin-top: 10px;
    padding: 0px 30px;
  }
`

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledHeading = styled(Heading)`
  font-size: 22px;
  line-height: 30px;
`

const StyledSubheading = styled(Bodytext)`
  color: ${style((theme) => theme.colors.stone)};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  margin-top: 5px;
`

interface Props {
  totalEtfCount: number
  handleEditPress: () => void
  totalStockCount?: number
  isCustomPortfolio?: boolean
}

export const InvestmentHeader = ({
  totalEtfCount = 0,
  totalStockCount = 0,
  isCustomPortfolio = false,
  handleEditPress,
}: Props) => {
  const { getRemoteString } = useRemoteStrings()
  return (
    <StyledOuterContainer>
      <StyledContainer>
        <StyledHeading>
          {getRemoteString({ key: 'invest.portfolio.assets.title' })}
        </StyledHeading>
        <StyledSubheading data-testid={PORTFOLIO_CUSTOM_SUBHEADER}>
          {getRemoteString({
            key:
              totalEtfCount > 1
                ? 'invest.portfolio.assets.subtitle.etfs.variable'
                : 'invest.portfolio.assets.subtitle.etf.variable',
            variables: [totalEtfCount.toString()],
          })}
          {isCustomPortfolio && (
            <>
              ,{' '}
              {getRemoteString({
                key:
                  totalStockCount > 1
                    ? 'invest.portfolio.assets.subtitle.stocks.variable'
                    : 'invest.portfolio.assets.subtitle.stock.variable',
                variables: [totalStockCount.toString()],
              })}
            </>
          )}
        </StyledSubheading>
      </StyledContainer>
      <Button
        className="custom-portfolio-edit-portfolio"
        testId={PORTFOLIO_ALL_EDIT_PORTFOLIO}
        onPress={handleEditPress}
        styleType="mini"
      >
        {getRemoteString({
          key: 'portfolio.cta.edit',
        })}
      </Button>
    </StyledOuterContainer>
  )
}
